import React, { Component } from "react";
import PropTypes from "prop-types";

import {
  Button,
  DropdownItem,
  DropdownToggle,
  ButtonDropdown,
  DropdownMenu,
  Spinner
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import { tableLanguage } from "common/Constants/PageTable/tableLang";
import BooleanCellRender from "./CellRenderers/BooleanCellRender";
import DateTimeCellRender from "./CellRenderers/DateTimeCellRender";
import DateCellRender from "./CellRenderers/DateCellRender";
import IncludeCellRenderer from "./CellRenderers/IncludeCellRenderer";
import ActivePassiveCellRender from "./CellRenderers/ActivePassiveCellRender";
import TimeCellRender from "./CellRenderers/TimeCellRender";

import { Breadcrumbs } from "../../CombinedComponents";

import * as moment from "moment";

import "ag-grid-enterprise";
import "ag-grid-enterprise/styles//ag-grid.css";
import "ag-grid-enterprise/styles//ag-theme-alpine.css";

import { uniqueIdentifier } from "./CellRenderers/CellFunctions";
import  ActionOperations  from "./CellRenderers/ActionOperations";
import { connect } from "react-redux";

class RavenAgSelectable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statusBar: {
        statusPanels: [{ statusPanel: "agAggregationComponent" }],
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading or try search panel instead.</span>',
      overlayNoRowsTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading or try search panel instead.</span>',
      rowSelection: this.props.singleSelection ? "single" : "multiple",
      isRowSelectable: params => {
        if (this.props.selectableObject) {
          return (
            this.props.selectableObject.values.some(x => params.data[this.props.selectableObject.condition] == x
              )
            
          );
        } else {
          return true;
        }
      },
      icons: {
        search: '<i class="fas fa-search fa-flip-both"/>',
      },
      selectedDataList: [],
      tooltipShowDelay: 0,
      tooltipHideDelay: 2000,
      sideBar: {
        toolPanels: [
          this.props.SearchContent
            ? {
                id: "search",
                labelDefault: this.props.t("search"),
                labelKey: "search",
                iconKey: "search",
                toolPanel: this.props.SearchContent,
              }
            : "",
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: false,
              suppressValues: false,
              suppressPivots: true,
              suppressPivotMode: true,
            },
          },
        ],
      },
      baseColumns : [
        {
          field: this.props.t(""),
          checkboxSelection: true,
          sort: 'desc',
          showDisabledCheckboxes: true,
          headerCheckboxSelection: !this.props.persoRequestSingle,
          maxWidth: 52,
          sortable: false,
          filter: false,
        },
        {
          field: this.props.t("actions"),
          cellRenderer: ActionOperations,
          cellRendererParams: {
            translate: this.props.t,
            edit: this.props.onEditClick,
            delete: this.props.onDeleteClick,
            detail: this.props.onDetailClick,
            dynamicFunction: this.props.onDynamicFunction,
            dynamicFunction2: this.props.onDynamicFunction2,
            dynamicFunctionIcon: this.props.dynamicFunctionIcon,
            dynamicFunctionIcon2: this.props.dynamicFunctionIcon2,
            dynamicFunctionName: this.props.dynamicFunctionName,
            dynamicFunctionName2: this.props.dynamicFunctionName2,
            dynamicFunctionStatus: this.props.dynamicFunctionStatus,
            dynamicFunctionStatus2: this.props.dynamicFunctionStatus2
          },
          singleClickEdit: true,
          suppressToolPanel: !this.props.actionItems,
          suppressColumnsToolPanel: !this.props.actionItems,
          maxWidth: 37,
          sortable: false,
          filter: false,
          hide: !this.props.actionItems,
        },
        ...this.props.recordcolumns,
      ],
      updatedColumns: [],
    };
  }


  componentDidUpdate() {
    if (
      this.state.updatedColumns.some(column => column.colDef.valueFormatter)
    ) {
      this.gridApi.aggFuncService && this.gridApi.refreshCells();
    }
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ updatedColumns: this.gridColumnApi.getColumns() });

    const columnDefs = this.gridColumnApi.getColumns().map(column => {
      const colDef = column.getColDef();

      return {
        ...colDef,
        minWidth: this.setMinWidthByHeaderName(
          column.colDef.headerName,
          column.colDef.minWidth
        ),
        flex: 1,
      };
    });

    this.gridApi.setColumnDefs(columnDefs);
    this.gridColumnApi.autoSizeColumns(
      columnDefs.map(column => column.colId),
      false
    );
  };

  setMinWidthByHeaderName = (headerName, minWidth) => {
    if (headerName) {
      if (minWidth > 0) {
        return minWidth;
      }
      if (headerName < 14) return 150;
      else if (headerName.length < 23) return 200;
      else return 250;
    }
    return 150;
  };
  
  onSelectionChanged = () => {
    let selectedRows = this.gridApi.getSelectedRows();
    this.setState({ selectedDataList: selectedRows });
    if(this.props.singleRowDataBinding)
    {
      this.props.singleRowDataBinding(this.gridApi.getSelectedRows())
    }
  };

  onBtnExportDataAsExcel = () => {
    let excelParams = {
      fileName:
        this.props.breadCrumbItem + moment().format("DD-MM-YYYY hh-mm-ss"),
    };
    this.gridApi.exportDataAsExcel(excelParams);
  };

  onBtnExportDataAsCsv = () => {
    let csvParams = {
      fileName:
        this.props.breadCrumbItem + moment().format("DD-MM-YYYY hh-mm-ss"),
    };
    this.gridApi.exportDataAsCsv(csvParams);
  };

  onFirstDataRendered = (params) => {
    const nodesToSelect = [];
    params.api.forEachNode((node) => {
      if(this.props.selectedData.some(x => x.guid ==node.data.guid )){
        node.setSelected(true)
        nodesToSelect.push(node);

      }
      
    });
    params.api.setNodesSelected({ nodes: nodesToSelect, newValue: true });
  };

  render() {
    const { recordList,loading } = this.props;
   
    const excelStyles = [
      {
        id: "stringType",
        dataType: "String" // Excel'de metin formatında olması için
      }
    ];

    return (
      <React.Fragment>
        <div className="d-flex align-items-center">
          <div className="mb-0 card flex-grow-1">
            <Breadcrumbs
              title={
                this.props.breadCrumbTitle ? this.props.breadCrumbTitle : ""
              }
              breadcrumbItem={
                this.props.breadCrumbTitle ? this.props.breadCrumbItem : ""
              }
            />
          </div>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div
              className="btn-group-horizantal"
              role="group"
            >
              <Button
                type="button"
                style={{
                  display: this.props.onAddClick ? "" : "none",
                  color: "#000000",
                }}
                color="link"
                className="btn btn-outline"
                onClick={() => this.props.onAddClick(this.state)}
              >
                <i
                  style={{ color: "#000000" }}
                  className={
                    this.props.mainButtonIcon
                      ? this.props.mainButtonIcon
                      : "bx bxs-file-plus font-size-15"
                  }
                ></i>{" "}
                {this.props.mainButton
                  ? this.props.t(this.props.mainButton)
                  : this.props.t("addNew")}
              </Button>
              <ButtonDropdown
                style={{ display: this.props.exportOption ? "" : "none" }}
                isOpen={this.state.exportDataDrp}
                toggle={() =>
                  this.setState({ exportDataDrp: !this.state.exportDataDrp })
                }
              >
                <DropdownToggle
                  style={{ color: "#000000" }}
                  caret
                  color="link"
                  className="btn btn-outline"
                >
                  <i
                    style={{ color: "#000000" }}
                    className="bx bx-export  font-size-15"
                  ></i>
                  {this.props.t("export")}
                </DropdownToggle>
                <DropdownMenu data-popper-placement="left">
                  <DropdownItem onClick={() => this.onBtnExportDataAsExcel()}>
                    {this.props.t("exportExcel")}
                  </DropdownItem>
                  <DropdownItem onClick={() => this.onBtnExportDataAsCsv()}>
                    {this.props.t("exportCsv")}
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
              <ButtonDropdown
                isOpen={this.state.operationsDrp}
                style={{ display: this.props.DropdownItems ? "" : "none" }}
                toggle={() =>
                  this.setState({ operationsDrp: !this.state.operationsDrp })
                }
              >
                <DropdownToggle caret color="link" className="btn btn-outline">
                  <i className="bx bx-dots-vertical-rounded font-size-16" />
                </DropdownToggle>
                <DropdownMenu data-popper-placement="left">
                  {this.props.DropdownItems ? (
                    this.props.DropdownItems.map((column) => (
                      <DropdownItem
                        key={uniqueIdentifier()}
                        onClick={() => column.func(this.state)}
                      >
                        {this.props.t(column.operationName)}
                      </DropdownItem>
                    ))
                  ) : (
                    <></>
                  )}
                </DropdownMenu>
              </ButtonDropdown>
            </div>
          </div>
        </div>
        <div
          className="ag-theme-alpine"
          style={{
            height: this.props.gridHeight ? this.props.gridHeight : "550px",
          }}
        >
          {loading ? (
                      <Spinner className="position-absolute top-50 start-50 primary" />
                    ) : (
          <AgGridReact
            defaultColDef={{
              flex: 1,
              sortable: true,
              filter: true,
              autosize: true,
              resizable: true,
              enableRowGroup: true,
              filterParams: {
                excelMode: 'windows',
                buttons: ["apply", "reset"],
              },
            }}
            components={{
              booleanCellRender: BooleanCellRender,
              dateTimeCellRender: DateTimeCellRender,
              dateCellRender: DateCellRender,
              timeCellRender: TimeCellRender,
              includeCellRenderer: IncludeCellRenderer,
              activePassiveCellRender: ActivePassiveCellRender,
            }}
            sideBar={this.state.sideBar}
            statusBar={this.state.statusBar}
            rowData={recordList}
            columnDefs={this.state.baseColumns}
            onRowClicked={
              this.props.rowClickFunc
                ? e => this.props.rowClickFunc(e.data)
                : ""
            }
            enableRangeSelection={true}
            icons={this.state.icons}
            suppressMenuHide={true}
            tooltipShowDelay={this.state.tooltipShowDelay}
            tooltipHideDelay={this.state.tooltipHideDelay}
            enableRangeHandle={true}
            overlayLoadingTemplate={this.state.overlayLoadingTemplate}
            overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
            rowSelection={this.state.rowSelection}
            onSelectionChanged={this.onSelectionChanged.bind(this)}
            animateRows={true}
            pagination={true}
            localeText={tableLanguage}
            onGridReady={this.onGridReady}
            paginationAutoPageSize={true}
            excelStyles={excelStyles}
            getRowNodeId={data => data.guid}
            isRowSelectable={this.state.isRowSelectable}
            onFirstDataRendered={this.props.selectedData ? this.onFirstDataRendered.bind(this) : null}
            rowMultiSelectWithClick={true}
          />)}
        </div>
      </React.Fragment>
    );
  }
}

RavenAgSelectable.propTypes = {
  loading:PropTypes.bool,
  mainButton: PropTypes.any,
  rowClickFunc: PropTypes.func,
  mainButtonIcon: PropTypes.any,
  onDynamicFunction: PropTypes.func,
  onDynamicFunction2: PropTypes.func,
  dynamicFunctionName: PropTypes.any,
  dynamicFunctionName2: PropTypes.any,
  dynamicFunctionIcon: PropTypes.any,
  dynamicFunctionIcon2: PropTypes.any,
  dynamicFunctionStatus: PropTypes.any,
  dynamicFunctionStatus2: PropTypes.any,
  selectableObject: PropTypes.any,
  gridHeight: PropTypes.string,
  onAddClick: PropTypes.func,
  onEditClick: PropTypes.func,
  actionItems: PropTypes.bool,
  SearchContent: PropTypes.any,
  DropdownItems: PropTypes.any,
  onDetailClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  onSearchClick: PropTypes.func,
  handleAddRecordClick: PropTypes.func,
  exportOption: PropTypes.bool,
  recordcolumns: PropTypes.any,
  recordList: PropTypes.any,
  breadCrumbTitle: PropTypes.string,
  breadCrumbItem: PropTypes.string,
  record: PropTypes.any,
  sizePerPage: PropTypes.any,
  show: PropTypes.any,
  singleSelection: PropTypes.any,
  singleRowDataBinding : PropTypes.func,
  persoRequestSingle : PropTypes.any,
  t: PropTypes.any,
  isRowSelectable: PropTypes.any,
  selectedData: PropTypes.any,
  rowMultiSelectWithClick: PropTypes.any,
  
};


export default connect()(withTranslation()(RavenAgSelectable));


